import { FormEvent } from 'react';
import { APP_WRAPPER_ID } from './constants';

export function openOnNewTab(href: string, target = '_blank') {
  const link = document.createElement('a');

  link.setAttribute('href', href);
  link.setAttribute('target', target);

  link.click();
}

// We are using vanilla JS to perform this task to prevent unnecessary ref management
// with our wrapper + a global context
export function scrollToWrapperTop() {
  const wrapper = document.getElementById(APP_WRAPPER_ID);

  wrapper?.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}

/**
 * Useful if you want to scape modals etc that manage state internally
 * and you don't want the hassle of managing the open/closed state
 *
 * Situational, better use in the abstracted version like the `existOverlay`
 * helper that uses this and is exported from the Overlays
 */
export function elementClick(id?: string) {
  const element = id ? document.getElementById(id) : document.body;

  if (!element) return;

  // Simulate a pointerdown and pointerup sequence to mimic a real mouse click
  element.dispatchEvent(new PointerEvent('pointerdown', { bubbles: true }));
  element.dispatchEvent(new PointerEvent('pointerup', { bubbles: true }));
}

type OnSubmitHandler = (e: FormEvent) => void;

/**
 * Automatically stop the default form behavior
 * to refresh the page on submit
 */
export function wrapFormAction(action: OnSubmitHandler): OnSubmitHandler {
  return (e) => {
    e.preventDefault();
    action(e);
  };
}
